<template>
  <div>
    <the-breadcrumbs></the-breadcrumbs>
    <page-content page-title="Veranstaltungsort bearbeiten">
      <event-location-form
        :loading="loading"
        :location="location"
        :form-submitted="saveLocation"
        mode="edit"
      ></event-location-form>
    </page-content>
  </div>
</template>

<script>
import TheBreadcrumbs from "@/components/TheBreadcrumbs"
import PageContent from "@/components/PageContent"
import EventLocationForm from "@/components/forms/EventLocationForm"
import EventLocationsRepository from "@/repositories/event_locations_repository.js"
import ApiErrorHandlerMixin from "@/mixins/api_error_handler.js"

export default {
  metaInfo: {
    title: "Veranstaltungsort bearbeiten"
  },
  components: {
    TheBreadcrumbs,
    PageContent,
    EventLocationForm
  },
  mixins: [ApiErrorHandlerMixin],
  data() {
    return {
      loading: true,
      location: {}
    }
  },
  async created() {
    try {
      this.location = await EventLocationsRepository.get(this.$route.params.id)
      this.loading = false
    } catch (error) {
      this.loading = false
      this.handleApiError(error)
    }
  },
  methods: {
    async saveLocation(location) {
      await EventLocationsRepository.update(location.id, location)
      this.$router.push({ name: "EventLocationsPage" })
    }
  }
}
</script>
